import React from "react";
import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/dashboard/Navbar";
import { ArrowLeft, Crown } from "lucide-react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import subscriptionRequests from "../../api/SubscriptionRequests";
import SubscriptionDataTable from "../../components/subscriptions/SubscriptionDataTable";

const UserSubscriptions = () => {
  const navigate = useNavigate();
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      setLoading(true);
      try {
        const response = await subscriptionRequests.getUserSubscription();
        if (response?.data?.status_code === "000") {
          setUserSubscriptions(response?.data?.data);
        } else {
          toast.error(
            response?.data?.reason || "Error fetching user subscriptions"
          );
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.reason || "Error fetching user subscriptions"
        );
      } finally {
        setLoading(false);
      }
    };
    fetchUserSubscriptions();
  }, []);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-gray-50 to-red-50">
        <div className="px-4 py-8 mx-auto max-w-8xl sm:px-6 lg:px-8">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-8"
          >
            <div className="flex justify-between items-start mb-6">
              <div className="flex gap-4 items-center">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                  className="p-4 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl shadow-lg"
                >
                  <Crown className="w-8 h-8 text-white" />
                </motion.div>
                <div>
                  <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-3xl font-bold text-gray-900"
                  >
                    User Subscriptions
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="text-lg text-gray-600"
                  >
                    Manage and monitor user subscription status and billing
                    information
                  </motion.p>
                </div>
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(-1)}
                className="inline-flex gap-2 items-center px-4 py-2 text-sm font-medium text-gray-600 bg-white rounded-lg shadow-sm transition-colors hover:bg-gray-50"
              >
                <ArrowLeft className="w-4 h-4" />
                Back
              </motion.button>
            </div>
          </motion.div>

          {/* Data Table */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <SubscriptionDataTable
              subscriptions={userSubscriptions}
              loading={loading}
            />
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default UserSubscriptions;
